export const CHANGE_STUDENT_EDUCATION_LICENSE_CLASS = "CHANGE_STUDENT_EDUCATION_LICENSE_CLASS";
export const FSC_WEB_ACCESS = "FSC_WEB_ACCESS";
export const DELETE_BOOKED_SERVICES = "DELETE_BOOKED_SERVICES";
